import { useSelector } from "react-redux";
import { FavoriteList } from "@interface/entities/favorites";
import StoreInterface from "@interface/store/index";

export default function useCheckFavorites(id: number) {
  const favoriteList = useSelector<StoreInterface, FavoriteList[]>((state) => state.Favorites.data);
  const isFavorited = !!favoriteList.find((item) => item.id === id);

  return isFavorited;
}
